import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import TimeAnalysisBarChart from '../cards/TimeAnalysisBarChart'
import TimeAnalysisTable from '../cards/TimeAnalysisTable.vue'
import TimeAnalysisPie from '../cards/TimeAnalysisPie'
import ExportModal from './ExportModal.vue'
import chartBar from '../cards/chartBar'
import './timeanalysis.less'
import dayjs from 'dayjs'
import { downloadFile } from "@/utils";
import { andonStatisticsExcelExport } from '@/api/api'

@Component({
  components: {
    TimeAnalysisBarChart,
    TimeAnalysisTable,
    TimeAnalysisPie,
    ExportModal,
    chartBar
  }
})
export default class TimeAnalysisBody extends Vue {
  @Prop({ default: () => ([]) }) tabsdData: Array<any>
  @Prop({ default: () => ([]) }) data: Array<any>
  @Prop({ default: () => ([]) }) chartData: Array<any>
  @Prop({ default: () => ([]) }) columns: Array<any>
  @Prop({ default: () => ({}) }) searchValue: any
  @Prop({ default: false }) loading: Boolean
  
  showType: String = 'bar'
  visible: Boolean = false
  checkItem = []
  defaultActiveKey = 0
  exportVisible = false // 导出弹框

  chartBody() {
    if (this.showType === 'bar') {
      return (
        this.chartData.map(item => {
          return <chartBar data={item} allData={this.data}/>
        })
      )
    } else {
      return (<time-analysis-table columns={this.columns} dataValue={ this.data }></time-analysis-table>)
    }
  }

  handleShowTypeChange(value) {
    this.showType = value
    this.checkItem = []
    this.data.forEach(res => {
      res.checked = false
    })
  }

  changeTabs(value){
    this.defaultActiveKey = value
    this.$emit('changeTabs',value)
  }

  callback(val) {
    console.log(val);
  }

  renderLoading(){
    return (
      <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 34px" spin />
        </a-spin>
      </div>
    )
  }

  export(){
    const dataList = []
    const weekList = []
    const monthList = []
    const yearList = []
    this.tabsdData.forEach(res =>{
      if(dataList.indexOf(res.date) === -1){
        dataList.push(res.date)
      }
      if(weekList.indexOf(res.week) === -1){
        weekList.push(res.week)
      }
      if(monthList.indexOf(res.month) === -1){
        monthList.push(res.month)
      }
      if(yearList.indexOf(res.year) === -1){
        yearList.push(res.year)
      }
    })
    const data = {
      dateList: dataList.reverse(),
      month: monthList.reverse(),
      statisticalMethod: this.searchValue.statisticalMethod,
      week: weekList.reverse(),
      shiftList:this.searchValue.shiftList,
      workStationIds: this.searchValue.workStationIds,
      year: yearList.length > 0 ? (yearList.reverse())[0] : 0,
      startDate:dayjs(this.searchValue.startDate).format('YYYY-MM-DD 00:00:00'),
      endDate:dayjs(this.searchValue.endDate).format('YYYY-MM-DD 23:59:59'),
    }
    andonStatisticsExcelExport(data).then(res => {
      let fileName = this.$t('page_andon_call_frequency_analysis')+'.xlsx'
      downloadFile(res,fileName)
    })

  }


  cancelExport(){
    this.exportVisible = false
  }

  caseMethod(value){
    let data = 1
    if(value === 'SHIFT'){
      data = 1
    } else if(value === 'DAY'){
      data = 2
    } else if(value === 'WEEK'){
      data = 3
    } else if(value === 'MONTH'){
      data = 4
    }
    return data
  }
  pushShiftIndexs(value){
    const data = []
    if(value && value.length > 0){
      value.forEach(res => {
        data.push(res.key)
      });
    }
    return data
  }

  pushShiftIndexNames(value){
    const data = []
    if(value && value.length > 0){
      value.forEach(res => {
        const key = res.key
        const name = res.name
        const vs = {}
        vs[key] = name
        data.push(key)
      });
    }
    return data
  }


  render() {
    return (
      <blank-view>
        <div slot="action">
          <div style="display: flex; justify-content: space-between;">
            <a-button type="primary" onClick={() => this.export()}>{this.$t('page_product_export')}</a-button>
            <a-radio-group value={this.showType} onChange={data => this.handleShowTypeChange(data.target.value)}>
              <a-radio-button value="bar">
                { this.$t('page_operation_statistics_barchart') }
              </a-radio-button>
              <a-radio-button value="table">
                { this.$t('page_operation_statistics_tablechart') }
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div style="height: 100%">
          <div style="width: 100%">
            <a-tabs
              active-key={this.defaultActiveKey}
              tab-position={'top'}
              onPrevClick={this.callback}
              onNnextClick={this.callback}
              onChange={value => this.changeTabs(value)}
            >
              {this.tabsdData.length > 0 ? this.tabsdData.map((res,index) =>{return (<a-tab-pane key={index} tab={res.title}></a-tab-pane>)}) : null}
            </a-tabs>
            { this.showType !== 'table' ? <div style="margin-bottom: 8px;">
               {this.columns.map((res) =>{return (<a-badge style="margin-left: 8px;" color={res.color} text={res.wcsName} />)})}
            </div> : null}
          </div>
          <div class="analysis-content">
            {this.loading ? this.renderLoading() : (this.data.length > 0 ? this.chartBody() : <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"><wm-empty text={this.$t('page_wm_empty')} /></div>) }
          </div>
        </div>
      </blank-view>
    )
  }
}